<template>
  <div class="info animate slideInRight">
    <span class="close show" @click="closed"></span>
    <div class="logInfo">
      <span class="tit show" v-html="$t('lan.leaveCon')"></span>
      <input class="inputNR click" @focus="focusfns" @blur="blurfns(1)" :class="isName ? 'wrong' : ''" value="" v-model="name" :placeholder=" nemeholder "/>
      <input class="inputNR" @blur="blurfns(2)" :class="isContact ? 'wrong' : ''" value="" v-model="contact" :placeholder=" pwdholder " />
      <textarea class="con" :placeholder=" $t('lan.Message') " v-model="content"></textarea>
      <div class="fleft codeYz m2B">
        <span class="btnsub show fleft" @click="subMess">{{$t('lan.send')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);
export default {
	name: 'app',
	components: {

	},
	props:{

	},
	data(){
		return {
			lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
			name:'',
			contact:'',
			isName:false,
			isContact:false,
			nemeholder:this.$t('lan.yourName'),
			pwdholder:this.$t('lan.phoneMail'),
			content:'',
		}
	},
	created() {

	},
	mounted(){

	},
	destroyed(){

	},
	methods:{
		closed(){
			this.$emit('closeBox',true)
		},
		focusfns(){
		  this.isName=false;
		  this.isContact=false;
		},
		blurfns(type){
		  if(type==1){
			if(this.name==''){
			  this.isName=true;
			}else{
			  this.isName=false;
			}
		  }else{
			if(this.contact==''){
			  this.isContact=true;
			}else{
			  this.isContact=false;
			}
		  }
		},
		async subMess(){
			var _this=this;
			var name=_this.name;
			var contact=_this.contact;
			var content=_this.content;
			var emil='';
			var tell='';
			if(name=='' || this.contact==''){
				this.isName = (name ==='') ? true : false;
				this.isContact = (contact ==='') ? true : false;
				return;
			}
			var reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
			if(contact.indexOf('@')>0){
				var emil=contact
			}else{
				var tell=contact;
			}
			let data = {
				userName : name,
				email: emil,
				phone: tell,
				company : content
			}
			await _this.$api.getMessage(data).then((res)=>{
				var res = res.data; 
				if( res.result=='success'){  
				  Dialog.alert({
					title: '温馨提示',
					message: this.$t('lan.abmiansd'),
				  }).then(() => {
					  this.$emit('closeBox',true)
				  });
				}else{
					Dialog.alert({
						title: '温馨提示',
						message: res.msg,
					}).then(() => {
						//this.$emit('closeBox',true)
					});
				}
			}).catch((err)=>{
				this.pwd=true;
				this.pwdholder=this.$t('lan.errorPwd');
				console.log("请求失败") 
			})
		},
	}
}
</script>
<style lang="scss" scoped>
    .info{
      width:750px;
      margin:0 auto;
      background: #fff;
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index: 2000;
      color:#4d4d4d;
    }
    .logInfo{
      width:670px;
      height:970px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-500px 0 0 -335px;
      font-size:26px;
      img{
        width:283px;
        height:89px;
      }
      .logo{
        width:100%;
        height:100px;
        text-align: center;
        img{
          width:300px;
          height:90px;
        }
      }
      .tit{
        width:645px;
        line-height:70px;
        font-size:36px;
        border-bottom:solid 1px #cbcbcb;
        padding:0 0 35px 25px;
      }
      .inputNR{
        width:630px;
        height:138px;
        line-height:138px;
        padding:0 20px;
        line-height:70px;
        margin-bottom:2px;
        border-bottom:solid 1px #cbcbcb;
      }
      .inputNR.click{
        border-bottom:solid 3px #00a8ff; 
      }
      .con{
        width:630px;
        padding:10px 20px;
        height:320px;
        line-height:50px;
        margin-top:20px;

      }
      .btnsub{
        width:100%;
        height:100px;
        line-height:100px;
        background:#0ca1ea;
        color:#fff;
        text-align: center;
        letter-spacing: 8px;
        font-size:36px;
       
      }
      .js{
        font-size:22px;
        line-height:150px;
      }
      .codeYz{
        width:100%;
        height:100px;
        overflow: hidden;
        line-height:100px;
        margin-top:40px;
      }
    }
    
</style>
